export default __webpack_public_path__ + "fonts/close-icon-white.svg";